import {
  CenterContent,
  CenterWrapper,
  DetailsCol,
} from '../EntitySelectionPanelUI';
import React from 'react';

const NoResultsPanel = () => {
  return (
    <DetailsCol>
      <CenterWrapper>
        <CenterContent>No Results</CenterContent>
      </CenterWrapper>
    </DetailsCol>
  );
};
export default NoResultsPanel;
